import React, {forwardRef, useEffect, useRef} from 'react';

import {TabLinkButton} from "../../../core/components/misc/buttons/tab-link-button";
import styles from "../styles/navigation-tabs.module.scss";
import classNames from "classnames";
import {Image} from "../../../core/components/image/image";
import {observer} from 'mobx-react';

export const NavigationTabsModuleButton = observer(forwardRef(({className, tab, onClick, isScrollable, useRouteProps}, forwardRef) => {
  const {isActive, isNoFollow, linkModel, name, hasIcon, isIconFirst, iconSource, index} = tab;

  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && isActive && isScrollable) {
      forwardRef.current?.scrollTo({left: ref.current.offsetLeft - (forwardRef.current.clientWidth / 2), top: 0, behavior: "smooth"});
    }
  }, [isActive, isScrollable]);

  const buttonProps = {
    tab,
    linkModel,
    noFollow: isNoFollow,
    routeProps: useRouteProps ? {tabIndex: index} : null,
    className: classNames(className, styles.button, {[styles.active_button]: isActive}, {[styles.reverse_icon]: hasIcon && isIconFirst}),
    onClick: () => onClick && onClick(tab)
  }

  const buttonNameContainerProps = {
    className: classNames(styles.name)
  }

  const iconProps = {
    className: classNames(styles.icon),
    src: iconSource
  }

  return (
    <TabLinkButton {...buttonProps}>
      <div {...buttonNameContainerProps} ref={ref}>{name}</div>
      {
        hasIcon ? <Image {...iconProps}/> : null
      }
    </TabLinkButton>
  );
}));
